import { AbstractControl, ValidatorFn } from '@angular/forms';
import {
  DEFAULT_ALLOWED_FILES,
  FileInputAllowedModel,
  FileInputAllowedTypeModel,
  FileInputModel,
  FileInputValueModel,
  FileValidationErrorCollection,
  FileValidationErrorModel,
  isAllowedFileType,
} from '@libs/form/models';

export class FileValidator {
  public static validateFn(item: FileInputModel): ValidatorFn {
    const options: FileInputAllowedModel = item.allowed ?? DEFAULT_ALLOWED_FILES;

    return (control: AbstractControl<FileInputValueModel[]>): FileValidationErrorCollection | null => {
      if (!Array.isArray(control.value)) {
        return null;
      }

      const results: FileValidationErrorModel[] = control.value
        .map(value => FileValidator.validateFile(value.file, options))
        .filter(error => !!error);

      if (results.length) {
        return { file: results };
      }

      return null;
    };
  }

  private static validateFile(file: File, options: FileInputAllowedModel): FileValidationErrorModel | null {
    if (!FileValidator.isValidSize(file, options.maxSize)) {
      return { data: file, maxSize: options.maxSize };
    }

    if (!FileValidator.isValidType(file, options.types)) {
      return { data: file, types: options.types };
    }

    return null;
  }

  private static isValidSize(file: File, maxSize: number): boolean {
    return file.size <= maxSize;
  }

  private static isValidType(file: File, types: FileInputAllowedTypeModel[]): boolean {
    return isAllowedFileType(file.name, file.type, types);
  }
}
